/* src/app/views/payment-method/payment-method.component.scss */
body .ui-corner-all {
  border-radius: 5px;
}
.margin-top-5 {
  margin-top: 5%;
}
.label-name-car {
  color: #2861A4;
  font-weight: bold;
  font-style: normal;
}
.client-data-title {
  font-weight: normal;
  font-style: normal;
  font-size: 36px;
  line-height: 50px;
  color: #000000;
  padding: 2%;
}
.client-data-field-name {
  font-weight: bold;
  font-style: normal;
  font-size: 20px;
  color: #000000;
}
.client-data-field-sub-name {
  font-weight: bold;
  font-style: normal;
  font-size: 16px;
  color: #000000;
}
.client-data-apply_margin_bottom {
  margin-bottom: 3%;
}
.client-data-message {
  display: grid;
  margin-top: 4px;
}
form {
  border-radius: unset;
  padding: unset;
  box-shadow: unset;
}
.container,
.contract-summary {
  width: 100%;
}
.payment-content-shell {
  display: flex;
  justify-content: center;
  width: 100%;
  padding-bottom: 24px;
  box-sizing: border-box;
}
.payment-content {
  width: min(1120px, 100% - 64px);
  margin: 0 auto;
  box-sizing: border-box;
}
:host ::ng-deep .payment-content .ui-fieldset,
:host ::ng-deep .payment-content .p-fieldset {
  margin: 0 0 24px;
  border-radius: 14px;
  overflow: hidden;
}
:host ::ng-deep .payment-content .ui-fieldset-content,
:host ::ng-deep .payment-content .p-fieldset-content {
  padding: 1.25rem 1.5rem;
}
:host ::ng-deep .payment-content .ui-tabview .ui-tabview-panels,
:host ::ng-deep .payment-content .p-tabview .p-tabview-panels {
  padding: 1rem 0 0;
}
.btn-next {
  width: auto;
  min-width: 170px;
  height: 48px;
  padding: 0 16px;
  margin-bottom: 2px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  white-space: nowrap;
}
.btn-back {
  width: auto;
  min-width: 170px;
  height: 48px;
  padding: 0 16px;
  margin-bottom: 2px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  white-space: nowrap;
}
.btn-pattern {
  min-height: 44px;
  padding: 0 16px;
  white-space: nowrap;
}
.search {
  position: relative;
  color: #aaa;
  font-size: 16px;
}
.search .fa-search {
  position: absolute;
  top: 20px;
}
.search .fa-search {
  left: 90%;
  color: #002F6C;
}
.summary-data-table td {
  padding: 6px 10px;
  vertical-align: top;
}
.summary-label {
  display: inline-block;
  font-size: 15px;
  line-height: 1.35;
  font-weight: 500;
  letter-spacing: normal;
  text-transform: none;
  color: #0f172a;
  margin-right: 6px;
}
.summary-value {
  display: inline-block;
  font-size: 12px;
  line-height: 1.25;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #6b7280;
  word-break: break-word;
}
@font-face {
  font-family: "BarcodeInterleaved2of5";
  src: url("./media/BarcodeInterleaved2of5-5C3UTQR5.ttf") format("truetype");
}
.barcodei2of5 {
  font-family: "BarcodeInterleaved2of5";
  font-size: 50px;
}
.outofstock {
  font-weight: 700;
  color: #FF5252;
  text-decoration: line-through;
}
.lowstock {
  font-weight: 700;
  color: #FFA726;
}
.instock {
  font-weight: 700;
  color: #66BB6A;
}
:host ::ng-deep .row-accessories {
  background-color: rgba(0, 0, 0, 0.15) !important;
}
.ui-table .ui-table-thead > tr > th {
  background: red;
}
@media only screen and (max-width: 1024px) {
  .summary-data-table td {
    padding: 6px 8px;
  }
  .summary-label {
    font-size: 14px;
  }
  .summary-value {
    font-size: 11px;
  }
}
@media only screen and (max-width: 700px) {
  .payment-content {
    width: calc(100% - 32px);
  }
  :host ::ng-deep .payment-content .ui-fieldset-content,
  :host ::ng-deep .payment-content .p-fieldset-content {
    padding: 1rem;
  }
  .btn-next,
  .btn-back,
  .btn-pattern {
    width: 100%;
  }
  .summary-data-table td {
    display: block;
    width: 100%;
    padding: 6px;
  }
  .summary-label,
  .summary-value {
    display: block;
  }
  .summary-label {
    margin-right: 0;
    margin-bottom: 2px;
  }
}
/*# sourceMappingURL=payment-method.component-FLET4C3Y.css.map */
